import { render, staticRenderFns } from "./TrendContainer.vue?vue&type=template&id=67690774&"
import script from "./TrendContainer.vue?vue&type=script&lang=js&"
export * from "./TrendContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports